/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  Upload: { input: any; output: any; }
};

export type AdminDisableUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type AllCetificationsResponse = {
  __typename?: 'AllCetificationsResponse';
  certifications?: Maybe<Array<Maybe<Plan>>>;
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type CancelSubscriptionInput = {
  subscription_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CancelSubscriptionResponse = {
  __typename?: 'CancelSubscriptionResponse';
  end_date?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Subscription>;
};

export type CancelledSubscriptionMetric = {
  __typename?: 'CancelledSubscriptionMetric';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  previousCount: Scalars['Int']['output'];
  previousDate: Scalars['String']['output'];
};

export type Card = {
  __typename?: 'Card';
  bank_code?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  card_number?: Maybe<Scalars['String']['output']>;
  customer_card_id?: Maybe<Scalars['String']['output']>;
  expiration_month?: Maybe<Scalars['String']['output']>;
  expiration_year?: Maybe<Scalars['String']['output']>;
  holder_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Cart = {
  __typename?: 'Cart';
  id?: Maybe<Scalars['Int']['output']>;
  plan?: Maybe<Plan>;
  plan_id?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export enum CartDescoutBy {
  LoggedIn = 'LOGGED_IN',
  ProPlan = 'PRO_PLAN',
  StandardPlan = 'STANDARD_PLAN',
  StudentPlan = 'STUDENT_PLAN'
}

export type CetificationsAvailableResponse = {
  __typename?: 'CetificationsAvailableResponse';
  certifications?: Maybe<Array<Maybe<Plan>>>;
  subscription?: Maybe<Subscription>;
};

export type ClaimCodeResponse = {
  __typename?: 'ClaimCodeResponse';
  convoy?: Maybe<ConvoyCode>;
};

export type Comment = {
  __typename?: 'Comment';
  created_at?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  post_id?: Maybe<Scalars['Int']['output']>;
  replies?: Maybe<Array<Maybe<ReplyComment>>>;
  updated_at?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type CommentsResponse = {
  __typename?: 'CommentsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<Comment>>>;
};

export type CommentsWhere = {
  post_id?: InputMaybe<Scalars['Int']['input']>;
  site?: InputMaybe<Site>;
};

export type ConnectResponse = {
  __typename?: 'ConnectResponse';
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type ConnectUserAppleInput = {
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectUserFacebookInput = {
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectUserGoogleInput = {
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ConvoyCode = {
  __typename?: 'ConvoyCode';
  code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ConvoyCodeStatuses>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export enum ConvoyCodeStatuses {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum CouponRequestType {
  Assigned = 'ASSIGNED',
  Available = 'AVAILABLE',
  Used = 'USED'
}

export enum CouponStatuses {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum CouponTypes {
  DiscountAmount = 'DISCOUNT_AMOUNT',
  DiscountAmountAndDuration = 'DISCOUNT_AMOUNT_AND_DURATION',
  DiscountAmountAndDurationAndVolume = 'DISCOUNT_AMOUNT_AND_DURATION_AND_VOLUME',
  DiscountAmountAndDurationAndVolumeWithMonths = 'DISCOUNT_AMOUNT_AND_DURATION_AND_VOLUME_WITH_MONTHS',
  DiscountAmountAndDurationWithMonths = 'DISCOUNT_AMOUNT_AND_DURATION_WITH_MONTHS',
  DiscountAmountAndVolume = 'DISCOUNT_AMOUNT_AND_VOLUME',
  DiscountAmountAndVolumeWithMonths = 'DISCOUNT_AMOUNT_AND_VOLUME_WITH_MONTHS',
  DiscountAmountWithMonths = 'DISCOUNT_AMOUNT_WITH_MONTHS',
  DiscountPercent = 'DISCOUNT_PERCENT',
  DiscountPercentAndDuration = 'DISCOUNT_PERCENT_AND_DURATION',
  DiscountPercentAndDurationAndVolume = 'DISCOUNT_PERCENT_AND_DURATION_AND_VOLUME',
  DiscountPercentAndDurationAndVolumeWithMonths = 'DISCOUNT_PERCENT_AND_DURATION_AND_VOLUME_WITH_MONTHS',
  DiscountPercentAndDurationWithMonths = 'DISCOUNT_PERCENT_AND_DURATION_WITH_MONTHS',
  DiscountPercentAndVolume = 'DISCOUNT_PERCENT_AND_VOLUME',
  DiscountPercentAndVolumeWithMonths = 'DISCOUNT_PERCENT_AND_VOLUME_WITH_MONTHS',
  DiscountPercentWithMonths = 'DISCOUNT_PERCENT_WITH_MONTHS'
}

export type CreateCartItemInput = {
  plan_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCommentInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  post_id?: InputMaybe<Scalars['Int']['input']>;
  site?: InputMaybe<Site>;
};

export type CreateCustomSubscriptionInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  payment_method: PaymentMethod;
  period_end_date: Scalars['String']['input'];
  period_start_date: Scalars['String']['input'];
  plan_id: Scalars['Int']['input'];
  transaction_id: Scalars['String']['input'];
  user_id: Scalars['Int']['input'];
};

export type CreateCustomSubscriptionResponse = {
  __typename?: 'CreateCustomSubscriptionResponse';
  subscription?: Maybe<Subscription>;
};

export type CreateOpenPayChargeInput = {
  billingInfo?: InputMaybe<SubscriptionBillingInput>;
  deviceDataId?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOpenPayChargeResponse = {
  __typename?: 'CreateOpenPayChargeResponse';
  redirect_url?: Maybe<Scalars['String']['output']>;
};

export type CreateOpenPaySubscriptionInput = {
  billingInfo?: InputMaybe<SubscriptionBillingInput>;
  deviceDataId?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['Int']['input']>;
  subscriptionUrl?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOpenPaySubscriptionResponse = {
  __typename?: 'CreateOpenPaySubscriptionResponse';
  subscription?: Maybe<Subscription>;
};

export type CreatePaypalSubscriptionInput = {
  billingInfo?: InputMaybe<SubscriptionBillingInput>;
  coupon?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['Int']['input']>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  subscriptionUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaypalSubscriptionResponse = {
  __typename?: 'CreatePaypalSubscriptionResponse';
  subscription?: Maybe<Subscription>;
};

export type CreateReplyCommentInput = {
  comment_id?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  post_id?: InputMaybe<Scalars['Int']['input']>;
  site?: InputMaybe<Site>;
};

export type CreateSharedCouponResponse = {
  __typename?: 'CreateSharedCouponResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateStripePaymentMethodInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStripePaymentMethodResponse = {
  __typename?: 'CreateStripePaymentMethodResponse';
  card?: Maybe<Card>;
};

export type CreateSubscriptionBillingInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  aditional_name?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  external_number?: InputMaybe<Scalars['String']['input']>;
  internal_number?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone1?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSubscriptionBillingResponse = {
  __typename?: 'CreateSubscriptionBillingResponse';
  subscriptionBilling?: Maybe<SubscriptionBilling>;
};

export type CreateUserInvitationInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRoles>;
};

export type CreateUserSavedPostInput = {
  post_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatedAtInput = {
  gte?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DeleteUserSavedPostInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type DisableUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type DisconnectResponse = {
  __typename?: 'DisconnectResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export type DisconnectUserProviderInput = {
  provider?: InputMaybe<SocialProviders>;
};

export type File = {
  encoding: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  mimetype: Scalars['String']['input'];
};

export enum FilterSocialProviders {
  All = 'ALL',
  Apple = 'APPLE',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
  System = 'SYSTEM'
}

export type ForgotPasswordPayload = {
  __typename?: 'ForgotPasswordPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  NoApply = 'NO_APPLY'
}

export type IdFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IdFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum InterestsEnum {
  AnimalGourmet = 'ANIMAL_GOURMET',
  AnimalMx = 'ANIMAL_MX',
  AnimalPolitico = 'ANIMAL_POLITICO',
  ElSabueso = 'EL_SABUESO',
  Newsweek = 'NEWSWEEK'
}

export type Invoice = {
  __typename?: 'Invoice';
  created_at?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  plan?: Maybe<Plan>;
  status?: Maybe<InvoiceStatuses>;
  transaction_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export enum InvoiceStatuses {
  Cancelled = 'CANCELLED',
  Paid = 'PAID',
  PaymentPending = 'PAYMENT_PENDING',
  Refunded = 'REFUNDED',
  Unpaid = 'UNPAID'
}

export type MailchimpAddSubscriptionInput = {
  audience?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type MailchimpAddSubscriptionResponse = {
  __typename?: 'MailchimpAddSubscriptionResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MailchimpAudience = {
  __typename?: 'MailchimpAudience';
  audience?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_subscribed?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MailchimpAudienceResponse = {
  __typename?: 'MailchimpAudienceResponse';
  count?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<MailchimpAudience>>>;
};

export type MailchimpSubscription = {
  __typename?: 'MailchimpSubscription';
  audience?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  unique_email_id?: Maybe<Scalars['String']['output']>;
};

export type MailchimpSubscriptionResponse = {
  __typename?: 'MailchimpSubscriptionResponse';
  subscriptions?: Maybe<Array<Maybe<MailchimpSubscription>>>;
};

export type MailchimpSubscriptionWhere = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addUserBroadcastData?: Maybe<AddUserBroadcastDataResponse>;
  addUserInterests?: Maybe<UserInterestsResponse>;
  addUserPreferencesData?: Maybe<AddUserPreferencesDataResponse>;
  adminDisableAccount?: Maybe<DisableAccountResponse>;
  appleSignup?: Maybe<AuthPayload>;
  cancelSubscription?: Maybe<CancelSubscriptionResponse>;
  cancelSubscriptionNow?: Maybe<CancelSubscriptionResponse>;
  changePassword?: Maybe<AuthPayload>;
  claimCode?: Maybe<ClaimCodeResponse>;
  connectUserApple?: Maybe<ConnectResponse>;
  connectUserFacebook?: Maybe<ConnectResponse>;
  connectUserGoogle?: Maybe<ConnectResponse>;
  createCartItem?: Maybe<Cart>;
  createComment?: Maybe<Comment>;
  createCustomSubscription?: Maybe<CreateCustomSubscriptionResponse>;
  createOpenPayCharge?: Maybe<CreateOpenPayChargeResponse>;
  createOpenPaySubscription?: Maybe<CreateOpenPaySubscriptionResponse>;
  createPaypalSubscription?: Maybe<CreatePaypalSubscriptionResponse>;
  createReplyComment?: Maybe<ReplyComment>;
  createSharedCoupon?: Maybe<CreateSharedCouponResponse>;
  createStripePaymentMethod?: Maybe<CreateStripePaymentMethodResponse>;
  createStudentCredential?: Maybe<StudentCredential>;
  createSubscriptionBilling?: Maybe<CreateSubscriptionBillingResponse>;
  createUserInvitation?: Maybe<UserInvitation>;
  createUserSavedPost?: Maybe<UserSavedPost>;
  deleteUserSavedPost?: Maybe<UserSavedPost>;
  disableAccount?: Maybe<DisableAccountResponse>;
  disconnectUserProvider?: Maybe<DisconnectResponse>;
  facebookSignup?: Maybe<AuthPayload>;
  forgotPassword?: Maybe<ForgotPasswordPayload>;
  googleSignIn?: Maybe<AuthPayload>;
  googleSignup?: Maybe<AuthPayload>;
  login?: Maybe<AuthPayload>;
  mailchimpAddSubscription?: Maybe<MailchimpAddSubscriptionResponse>;
  reactivateSubscription?: Maybe<Subscription>;
  recaptcha?: Maybe<RecaptchaResponse>;
  removeCartItem?: Maybe<Cart>;
  removeUserInvitation?: Maybe<RemoveUserInvitationPayload>;
  resendUserInvitation?: Maybe<UserInvitation>;
  signup?: Maybe<AuthPayload>;
  subscriptionsNextExpireReport?: Maybe<Report>;
  toggleAdministratorUserRole?: Maybe<User>;
  updateCard?: Maybe<UpdateCardResponse>;
  updateCartDiscount?: Maybe<Array<Maybe<Cart>>>;
  updateCustomSubscription?: Maybe<UpdateCustomSubscriptionResponse>;
  updateSubscription?: Maybe<Subscription>;
  updateSubscriptionBilling?: Maybe<UpdateSubscriptionBillingResponse>;
  updateUser?: Maybe<User>;
  updateUserEmail?: Maybe<UpdateUserEmailResponse>;
  updateUserInvitation?: Maybe<UserInvitation>;
  updateUserandRoles?: Maybe<User>;
};


export type MutationAddUserBroadcastDataArgs = {
  data?: InputMaybe<AddUserBroadcastDataInput>;
};


export type MutationAddUserInterestsArgs = {
  data?: InputMaybe<AddInterestsToUserInput>;
};


export type MutationAddUserPreferencesDataArgs = {
  data?: InputMaybe<AddUserPreferencesInput>;
};


export type MutationAdminDisableAccountArgs = {
  data?: InputMaybe<AdminDisableUserInput>;
};


export type MutationAppleSignupArgs = {
  site: Site;
  token: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationCancelSubscriptionArgs = {
  data?: InputMaybe<CancelSubscriptionInput>;
};


export type MutationCancelSubscriptionNowArgs = {
  data?: InputMaybe<CancelSubscriptionInput>;
};


export type MutationChangePasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationConnectUserAppleArgs = {
  data: ConnectUserAppleInput;
};


export type MutationConnectUserFacebookArgs = {
  data: ConnectUserFacebookInput;
};


export type MutationConnectUserGoogleArgs = {
  data: ConnectUserGoogleInput;
};


export type MutationCreateCartItemArgs = {
  data?: InputMaybe<CreateCartItemInput>;
};


export type MutationCreateCommentArgs = {
  data?: InputMaybe<CreateCommentInput>;
};


export type MutationCreateCustomSubscriptionArgs = {
  data?: InputMaybe<CreateCustomSubscriptionInput>;
};


export type MutationCreateOpenPayChargeArgs = {
  data?: InputMaybe<CreateOpenPayChargeInput>;
};


export type MutationCreateOpenPaySubscriptionArgs = {
  data?: InputMaybe<CreateOpenPaySubscriptionInput>;
};


export type MutationCreatePaypalSubscriptionArgs = {
  data?: InputMaybe<CreatePaypalSubscriptionInput>;
};


export type MutationCreateReplyCommentArgs = {
  data?: InputMaybe<CreateReplyCommentInput>;
};


export type MutationCreateSharedCouponArgs = {
  coupon_id: Scalars['Int']['input'];
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateStripePaymentMethodArgs = {
  data?: InputMaybe<CreateStripePaymentMethodInput>;
};


export type MutationCreateStudentCredentialArgs = {
  data?: InputMaybe<StudentCredentialInput>;
};


export type MutationCreateSubscriptionBillingArgs = {
  data?: InputMaybe<CreateSubscriptionBillingInput>;
};


export type MutationCreateUserInvitationArgs = {
  data?: InputMaybe<CreateUserInvitationInput>;
};


export type MutationCreateUserSavedPostArgs = {
  data?: InputMaybe<CreateUserSavedPostInput>;
};


export type MutationDeleteUserSavedPostArgs = {
  data?: InputMaybe<DeleteUserSavedPostInput>;
};


export type MutationDisableAccountArgs = {
  data?: InputMaybe<DisableUserInput>;
};


export type MutationDisconnectUserProviderArgs = {
  data: DisconnectUserProviderInput;
};


export type MutationFacebookSignupArgs = {
  site: Site;
  token: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
  form: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type MutationGoogleSignInArgs = {
  site: Site;
  token: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationGoogleSignupArgs = {
  site: Site;
  token: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationMailchimpAddSubscriptionArgs = {
  data?: InputMaybe<MailchimpAddSubscriptionInput>;
};


export type MutationReactivateSubscriptionArgs = {
  data?: InputMaybe<ReactivateSubscriptionInput>;
};


export type MutationRecaptchaArgs = {
  email: Scalars['String']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationRemoveCartItemArgs = {
  data?: InputMaybe<RemoveCartItemInput>;
};


export type MutationRemoveUserInvitationArgs = {
  id: Scalars['String']['input'];
};


export type MutationResendUserInvitationArgs = {
  id: Scalars['String']['input'];
};


export type MutationSignupArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  site: Site;
  url: Scalars['String']['input'];
};


export type MutationSubscriptionsNextExpireReportArgs = {
  data?: InputMaybe<SubscriptionsNextExpireReportInput>;
};


export type MutationToggleAdministratorUserRoleArgs = {
  data?: InputMaybe<ToggleAdministratorUserRoleInput>;
};


export type MutationUpdateCardArgs = {
  data?: InputMaybe<UpdateCardInput>;
};


export type MutationUpdateCartDiscountArgs = {
  data?: InputMaybe<UpdateCartDiscountInput>;
};


export type MutationUpdateCustomSubscriptionArgs = {
  data?: InputMaybe<UpdateCustomSubscriptionInput>;
};


export type MutationUpdateSubscriptionArgs = {
  data?: InputMaybe<UpdateSubscriptionInput>;
};


export type MutationUpdateSubscriptionBillingArgs = {
  data?: InputMaybe<UpdateSubscriptionBillingInput>;
};


export type MutationUpdateUserArgs = {
  data?: InputMaybe<UpdateUserInput>;
};


export type MutationUpdateUserEmailArgs = {
  data?: InputMaybe<UpdateUserEmailInput>;
};


export type MutationUpdateUserInvitationArgs = {
  data?: InputMaybe<UpdateUserInvitationInput>;
};


export type MutationUpdateUserandRolesArgs = {
  data?: InputMaybe<UpdateUserWithRolesInput>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Notification = {
  __typename?: 'Notification';
  created_at?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type NotificationResponse = {
  __typename?: 'NotificationResponse';
  count?: Maybe<Scalars['Int']['output']>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
};

export type OpenPay = {
  __typename?: 'OpenPay';
  first_payment_price?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  open_pay_id?: Maybe<Scalars['String']['output']>;
  plan_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<OpenPayStatuses>;
};

export enum OpenPayStatuses {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum PaymentMethod {
  Custom = 'CUSTOM',
  Openpay = 'OPENPAY',
  Paypal = 'PAYPAL',
  StripeCard = 'STRIPE_CARD'
}

export type Paypal = {
  __typename?: 'Paypal';
  id?: Maybe<Scalars['Int']['output']>;
  paypal_id?: Maybe<Scalars['String']['output']>;
  plan_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<PaypalStatuses>;
};

export enum PaypalStatuses {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type Plan = {
  __typename?: 'Plan';
  description?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<PlanFrequency>;
  helper_text?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_premium?: Maybe<Scalars['Boolean']['output']>;
  open_pay?: Maybe<OpenPay>;
  paypal?: Maybe<Paypal>;
  price?: Maybe<Scalars['String']['output']>;
  promo_subsidiary?: Maybe<Array<Maybe<Promo_Subsidiary_Type>>>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PlanStatuses>;
  stripe?: Maybe<Stripe>;
  sub_title?: Maybe<Scalars['String']['output']>;
  subscription_billing_is_required?: Maybe<Scalars['Boolean']['output']>;
  subscription_student_credential_is_required?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_front?: Maybe<Scalars['String']['output']>;
};

export enum PlanFrequency {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type PlanResponse = {
  __typename?: 'PlanResponse';
  items?: Maybe<Array<Maybe<Plan>>>;
};

export enum PlanStatuses {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type PlanWhereInput = {
  status?: InputMaybe<PaypalStatuses>;
};

export type PlansWhereInput = {
  is_premium?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<PaypalStatuses>;
};

export type Promo_Subsidiary_Type = {
  __typename?: 'Promo_subsidiary_type';
  description_first_line?: Maybe<Scalars['String']['output']>;
  description_second_line?: Maybe<Scalars['String']['output']>;
  header_subsidiary?: Maybe<Scalars['String']['output']>;
  identity_color?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  text_color?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  allCertifications?: Maybe<AllCetificationsResponse>;
  cancelledSubscriptionsMetrics?: Maybe<Array<CancelledSubscriptionMetric>>;
  certificationsAvailable?: Maybe<CetificationsAvailableResponse>;
  comments?: Maybe<CommentsResponse>;
  currentUser?: Maybe<User>;
  easyDataUsers?: Maybe<UsersPayload>;
  fetchCoupon?: Maybe<StripeCoupon>;
  getUserCart?: Maybe<Array<Maybe<Cart>>>;
  mailchimpAudiences?: Maybe<MailchimpAudienceResponse>;
  mailchimpSubscriptions?: Maybe<MailchimpSubscriptionResponse>;
  notificationList?: Maybe<NotificationResponse>;
  plan?: Maybe<Plan>;
  plans?: Maybe<PlanResponse>;
  stripeCouponList?: Maybe<StripeCouponListResponse>;
  subscriptionCancelledByFilter?: Maybe<SubscriptionCancelledByFilter>;
  user?: Maybe<User>;
  userInvitations?: Maybe<UserInvitationsResponse>;
  userProviders?: Maybe<UserSocialProvidersResponse>;
  userSavedPosts?: Maybe<UserSavedPostsResponse>;
  userSubscriberEvents?: Maybe<UsersSubscriberEventsPayload>;
  users?: Maybe<UsersPayload>;
  validateCoupon?: Maybe<StripeCoupon>;
};


export type QueryCancelledSubscriptionsMetricsArgs = {
  where: SubscriptionCancelWhereInput;
};


export type QueryCommentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommentsWhere>;
};


export type QueryEasyDataUsersArgs = {
  orderBy?: InputMaybe<Array<InputMaybe<UserOrderInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UsersWhere>;
};


export type QueryFetchCouponArgs = {
  couponCode: Scalars['String']['input'];
  plan_id: Scalars['Int']['input'];
};


export type QueryMailchimpSubscriptionsArgs = {
  where?: InputMaybe<MailchimpSubscriptionWhere>;
};


export type QueryNotificationListArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationsWhere>;
};


export type QueryPlanArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlansArgs = {
  where?: InputMaybe<PlansWhereInput>;
};


export type QueryStripeCouponListArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StripeCouponListWhere>;
};


export type QuerySubscriptionCancelledByFilterArgs = {
  where: SubscriptionCancelledByFilterInput;
};


export type QueryUserArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserInvitationsArgs = {
  data?: InputMaybe<UserInvitationsInput>;
};


export type QueryUserProvidersArgs = {
  orderBy?: InputMaybe<Array<InputMaybe<UserSocialProvidersOrderInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserSocialProvidersWhereInput>;
};


export type QueryUserSavedPostsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserSavedPostsWhere>;
};


export type QueryUserSubscriberEventsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UsersSubscriberEventsWhere>;
};


export type QueryUsersArgs = {
  orderBy?: InputMaybe<Array<InputMaybe<UserOrderInput>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UsersWhere>;
};


export type QueryValidateCouponArgs = {
  couponCode: Scalars['String']['input'];
  plan_id: Scalars['Int']['input'];
};

export type ReactivateSubscriptionInput = {
  subscription_id?: InputMaybe<Scalars['Int']['input']>;
};

export type RecaptchaResponse = {
  __typename?: 'RecaptchaResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveCartItemInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type RemoveUserInvitationPayload = {
  __typename?: 'RemoveUserInvitationPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ReplyComment = {
  __typename?: 'ReplyComment';
  comment_id?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  post_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Report = {
  __typename?: 'Report';
  count_files?: Maybe<Scalars['Int']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Maybe<ReportFile>>>;
  from_date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requested_by?: Maybe<Scalars['String']['output']>;
  site?: Maybe<Site>;
  status?: Maybe<StatusReport>;
  status_message?: Maybe<Scalars['String']['output']>;
  to_date?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ReportTypes>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type ReportFile = {
  __typename?: 'ReportFile';
  created_at?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Report>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export enum ReportTypes {
  SubscriptionNextExpireReport = 'SUBSCRIPTION_NEXT_EXPIRE_REPORT',
  SubscriptionReport = 'SUBSCRIPTION_REPORT',
  UserReport = 'USER_REPORT',
  WinnerNotesReport = 'WINNER_NOTES_REPORT'
}

export type RolesOnUsers = {
  __typename?: 'RolesOnUsers';
  role?: Maybe<UserRole>;
  role_id?: Maybe<Scalars['Int']['output']>;
};

export enum Site {
  AnimalPolitico = 'ANIMAL_POLITICO',
  CriterioHidalgo = 'CRITERIO_HIDALGO'
}

export enum SocialProviders {
  Apple = 'APPLE',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
  System = 'SYSTEM'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortTableInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<SortOrder>;
};

export enum StatusReport {
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Stripe = {
  __typename?: 'Stripe';
  created_at?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  plan_id?: Maybe<Scalars['Int']['output']>;
  price_id?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type StripeCoupon = {
  __typename?: 'StripeCoupon';
  assigned_to_share?: Maybe<Scalars['Boolean']['output']>;
  coupon?: Maybe<Scalars['String']['output']>;
  coupon_type?: Maybe<CouponTypes>;
  created_at?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['Int']['output']>;
  discount_percent?: Maybe<Scalars['Int']['output']>;
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_for_sharing?: Maybe<Scalars['Boolean']['output']>;
  is_public?: Maybe<Scalars['Boolean']['output']>;
  max_redemptions?: Maybe<Scalars['Int']['output']>;
  paypal_coupon_plan?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  plan_names?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CouponStatuses>;
  stripe_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  used_at?: Maybe<Scalars['String']['output']>;
};

export type StripeCouponListResponse = {
  __typename?: 'StripeCouponListResponse';
  count?: Maybe<Scalars['Int']['output']>;
  coupons?: Maybe<Array<Maybe<StripeCoupon>>>;
};

export type StudentCredential = {
  __typename?: 'StudentCredential';
  created_at?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  school?: Maybe<Scalars['String']['output']>;
  school_contact_number?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  student_card?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type StudentCredentialDataInput = {
  expiration_date?: InputMaybe<Scalars['String']['input']>;
  school?: InputMaybe<Scalars['String']['input']>;
  school_contact_number?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
};

export type StudentCredentialInput = {
  file?: InputMaybe<Scalars['Upload']['input']>;
};

export type SubscriberEvent = {
  __typename?: 'SubscriberEvent';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  cancel_date?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['String']['output']>;
  has_change_plan?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_cancel?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<PaymentMethod>;
  period_end_date?: Maybe<Scalars['String']['output']>;
  period_start_date?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  status?: Maybe<SubscriptionStatuses>;
  subscription_url?: Maybe<Scalars['String']['output']>;
  transaction_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SubscriptionType>;
  updated_at?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type SubscriptionBilling = {
  __typename?: 'SubscriptionBilling';
  address?: Maybe<Scalars['String']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  aditional_name?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  external_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  internal_number?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phone1?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionBillingInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  aditional_name?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  external_number?: InputMaybe<Scalars['String']['input']>;
  internal_number?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone1?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionCancelWhereInput = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type SubscriptionCancelledByFilter = {
  __typename?: 'SubscriptionCancelledByFilter';
  items: Array<Subscription>;
  total: Scalars['Int']['output'];
};

export type SubscriptionCancelledByFilterInput = {
  from: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  to: Scalars['String']['input'];
};

export enum SubscriptionStatuses {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Inactive = 'INACTIVE',
  Updated = 'UPDATED'
}

export enum SubscriptionType {
  Payment = 'PAYMENT',
  RecurrentPayment = 'RECURRENT_PAYMENT'
}

export type SubscriptionsNextExpireReportInput = {
  monthExpire: Scalars['String']['input'];
  payment_method?: InputMaybe<Scalars['String']['input']>;
  requested_by: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCardInput = {
  card_number?: InputMaybe<Scalars['String']['input']>;
  cvv2?: InputMaybe<Scalars['String']['input']>;
  device_session_id?: InputMaybe<Scalars['String']['input']>;
  expiration_month?: InputMaybe<Scalars['String']['input']>;
  expiration_year?: InputMaybe<Scalars['String']['input']>;
  holder_name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCardResponse = {
  __typename?: 'UpdateCardResponse';
  card?: Maybe<Card>;
};

export type UpdateCartDiscountInput = {
  discount?: InputMaybe<CartDescoutBy>;
};

export type UpdateCustomSubscriptionInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<PaymentMethod>;
  period_end_date?: InputMaybe<Scalars['String']['input']>;
  period_start_date?: InputMaybe<Scalars['String']['input']>;
  plan_id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<SubscriptionStatuses>;
  subscription_id: Scalars['Int']['input'];
  transaction_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomSubscriptionResponse = {
  __typename?: 'UpdateCustomSubscriptionResponse';
  subscription?: Maybe<Subscription>;
};

export type UpdateSubscriptionBillingInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  aditional_name?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  external_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  internal_number?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone1?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionBillingResponse = {
  __typename?: 'UpdateSubscriptionBillingResponse';
  subscriptionBilling?: Maybe<SubscriptionBilling>;
};

export type UpdateSubscriptionInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  payment_method_type?: InputMaybe<PaymentMethod>;
  plan_id?: InputMaybe<Scalars['Int']['input']>;
  subscriptionBilling?: InputMaybe<SubscriptionBillingInput>;
  subscription_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserEmailInput = {
  new_email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserEmailResponse = {
  __typename?: 'UpdateUserEmailResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateUserInput = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  user?: InputMaybe<UserInput>;
};

export type UpdateUserInvitationInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserInvitationStatuses>;
};

export type UpdateUserWithRolesInput = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  newRoles?: InputMaybe<Array<InputMaybe<UserRoles>>>;
  user?: InputMaybe<UserInput>;
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Scalars['String']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  broadcast_user_data?: Maybe<UserBroadcastData>;
  card?: Maybe<Card>;
  convoy_code?: Maybe<ConvoyCode>;
  created_at?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  id: Scalars['Int']['output'];
  interests?: Maybe<Array<Maybe<UserInterests>>>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  name: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  post_saved?: Maybe<Array<Maybe<UserSavedPost>>>;
  roles_on_users?: Maybe<Array<Maybe<RolesOnUsers>>>;
  site?: Maybe<Site>;
  social_providers?: Maybe<Array<Maybe<UserSocialProviders>>>;
  student_credential?: Maybe<StudentCredential>;
  subscription_billing?: Maybe<SubscriptionBilling>;
  subscriptions?: Maybe<Array<Maybe<Subscription>>>;
  updated_at?: Maybe<Scalars['String']['output']>;
  user_status?: Maybe<UserStatus>;
};

export type UserInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  remember_token?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Site>;
  updated_at?: InputMaybe<Scalars['String']['input']>;
};

export type UserInvitation = {
  __typename?: 'UserInvitation';
  created_at?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserRoles>;
  status?: Maybe<UserInvitationStatuses>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export enum UserInvitationStatuses {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type UserInvitationWhereInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRoles>;
  status?: InputMaybe<UserInvitationStatuses>;
};

export type UserInvitationsResponse = {
  __typename?: 'UserInvitationsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<UserInvitation>>>;
};

export type UserOrderInput = {
  created_at?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  user_status?: InputMaybe<SortOrder>;
};

export type UserProviderPayload = {
  __typename?: 'UserProviderPayload';
  count?: Maybe<Scalars['Int']['output']>;
  userProviders?: Maybe<Array<Maybe<UserSocialProviders>>>;
};

export type UserProvidersWhere = {
  created_at?: InputMaybe<CreatedAtInput>;
  provider?: InputMaybe<SocialProviders>;
};

export type UserRole = {
  __typename?: 'UserRole';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<UserRoles>;
};

export enum UserRoles {
  Administrator = 'ADMINISTRATOR',
  Editor = 'EDITOR',
  Suscriptor = 'SUSCRIPTOR',
  User = 'USER'
}

export type UserSavedPost = {
  __typename?: 'UserSavedPost';
  created_at?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  post_id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type UserSavedPostRestApi = {
  __typename?: 'UserSavedPostRestApi';
  id?: Maybe<Scalars['Int']['output']>;
  post_content?: Maybe<Scalars['String']['output']>;
  post_date?: Maybe<Scalars['String']['output']>;
  post_id?: Maybe<Scalars['Int']['output']>;
  post_image?: Maybe<Scalars['String']['output']>;
  post_name?: Maybe<Scalars['String']['output']>;
  post_terms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  post_title?: Maybe<Scalars['String']['output']>;
  post_type?: Maybe<Scalars['String']['output']>;
  post_uri?: Maybe<Scalars['String']['output']>;
  post_url?: Maybe<Scalars['String']['output']>;
  sub_post_type?: Maybe<Scalars['String']['output']>;
};

export type UserSavedPostsResponse = {
  __typename?: 'UserSavedPostsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  posts?: Maybe<Array<Maybe<UserSavedPostRestApi>>>;
};

export type UserSavedPostsWhere = {
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UserSocialProviders = {
  __typename?: 'UserSocialProviders';
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  primary?: Maybe<Scalars['Boolean']['output']>;
  provider?: Maybe<SocialProviders>;
  provider_id?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  url_register?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<User>;
};

export type UserSocialProvidersListRelationFilter = {
  every?: InputMaybe<UserSocialProvidersWhereInput>;
  none?: InputMaybe<UserSocialProvidersWhereInput>;
  some?: InputMaybe<UserSocialProvidersWhereInput>;
};

export type UserSocialProvidersOrderInput = {
  created_at?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type UserSocialProvidersResponse = {
  __typename?: 'UserSocialProvidersResponse';
  count?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<UserSocialProviders>>>;
};

export type UserSocialProvidersWhereInput = {
  created_at?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<SocialProviders>;
};

export enum UserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type UserSubscriberEvent = {
  __typename?: 'UserSubscriberEvent';
  created_at?: Maybe<Scalars['String']['output']>;
  event?: Maybe<SubscriberEvent>;
  event_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type UsersPayload = {
  __typename?: 'UsersPayload';
  count?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<User>>>;
};

export type UsersSubscriberEventsPayload = {
  __typename?: 'UsersSubscriberEventsPayload';
  count?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<UserSubscriberEvent>>>;
};

export type UsersSubscriberEventsWhere = {
  created_at?: InputMaybe<CreatedAtInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type UsersWhere = {
  OR?: InputMaybe<Array<InputMaybe<UsersWhere>>>;
  created_at?: InputMaybe<CreatedAtInput>;
  email?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  onlySubscribers?: InputMaybe<Scalars['Boolean']['input']>;
  provider?: InputMaybe<FilterSocialProviders>;
  site?: InputMaybe<Site>;
};

export type AddInterestsToUserInput = {
  interests?: InputMaybe<Array<InputMaybe<InterestsEnum>>>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AddUserBroadcastDataInput = {
  must_send?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type AddUserBroadcastDataResponse = {
  __typename?: 'addUserBroadcastDataResponse';
  data?: Maybe<UserBroadcastData>;
};

export type AddUserPreferencesDataResponse = {
  __typename?: 'addUserPreferencesDataResponse';
  data?: Maybe<AddUserPreferencesDataType>;
};

export type AddUserPreferencesDataType = {
  __typename?: 'addUserPreferencesDataType';
  broadcast?: Maybe<UserBroadcastData>;
  interests?: Maybe<Array<Maybe<UserInterests>>>;
};

export type AddUserPreferencesInput = {
  interests?: InputMaybe<Array<InputMaybe<InterestsEnum>>>;
  must_send?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type DisableAccountResponse = {
  __typename?: 'disableAccountResponse';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationsWhere = {
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type StripeCouponListWhere = {
  requestType?: InputMaybe<CouponRequestType>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type ToggleAdministratorUserRoleInput = {
  user_id: Scalars['Int']['input'];
};

export type UserBroadcastData = {
  __typename?: 'userBroadcastData';
  id?: Maybe<Scalars['Int']['output']>;
  must_send?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type UserInterests = {
  __typename?: 'userInterests';
  created_at?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  interest?: Maybe<InterestsEnum>;
  updated_at?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type UserInterestsResponse = {
  __typename?: 'userInterestsResponse';
  data?: Maybe<Array<Maybe<UserInterests>>>;
};

export type UserInvitationsInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortTableInput>;
  where?: InputMaybe<UserInvitationWhereInput>;
};

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthPayload', token: string | null, user: { __typename?: 'User', id: number } | null } | null };

export type SignupMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
  site: Site;
}>;


export type SignupMutation = { __typename?: 'Mutation', signup: { __typename?: 'AuthPayload', token: string | null, user: { __typename?: 'User', id: number } | null } | null };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
  form: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'ForgotPasswordPayload', success: boolean | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'AuthPayload', token: string | null, user: { __typename?: 'User', id: number } | null } | null };

export type GoogleSignInMutationVariables = Exact<{
  token: Scalars['String']['input'];
  url: Scalars['String']['input'];
  site: Site;
}>;


export type GoogleSignInMutation = { __typename?: 'Mutation', googleSignup: { __typename?: 'AuthPayload', token: string | null, user: { __typename?: 'User', id: number } | null } | null };

export type PlansQueryVariables = Exact<{
  where?: InputMaybe<PlansWhereInput>;
}>;


export type PlansQuery = { __typename?: 'Query', plans: { __typename?: 'PlanResponse', items: Array<{ __typename?: 'Plan', id: number | null, title: string | null, title_front: string | null, sub_title: string | null, description: string | null, helper_text: string | null, price: string | null, status: PlanStatuses | null, frequency: PlanFrequency | null } | null> | null } | null };

export type SubscriptionsNextExpireReportMutationVariables = Exact<{
  data?: InputMaybe<SubscriptionsNextExpireReportInput>;
}>;


export type SubscriptionsNextExpireReportMutation = { __typename?: 'Mutation', subscriptionsNextExpireReport: { __typename?: 'Report', id: number | null, name: string | null, type: ReportTypes | null, count_files: number | null, requested_by: string | null, status: StatusReport | null, site: Site | null, status_message: string | null, from_date: string | null, to_date: string | null, created_at: string | null, updated_at: string | null, files: Array<{ __typename?: 'ReportFile', id: number | null, name: string | null, path: string | null, created_at: string | null, updated_at: string | null } | null> | null } | null };

export type UserInvitationsQueryVariables = Exact<{
  data?: InputMaybe<UserInvitationsInput>;
}>;


export type UserInvitationsQuery = { __typename?: 'Query', userInvitations: { __typename?: 'UserInvitationsResponse', count: number | null, items: Array<{ __typename?: 'UserInvitation', id: string | null, role: UserRoles | null, email: string | null, status: UserInvitationStatuses | null, created_at: string | null, updated_at: string | null } | null> | null } | null };

export type CreateUserInvitationMutationVariables = Exact<{
  data?: InputMaybe<CreateUserInvitationInput>;
}>;


export type CreateUserInvitationMutation = { __typename?: 'Mutation', createUserInvitation: { __typename?: 'UserInvitation', id: string | null, role: UserRoles | null, email: string | null, status: UserInvitationStatuses | null, created_at: string | null, updated_at: string | null } | null };

export type UpdateUserInvitationMutationVariables = Exact<{
  data?: InputMaybe<UpdateUserInvitationInput>;
}>;


export type UpdateUserInvitationMutation = { __typename?: 'Mutation', updateUserInvitation: { __typename?: 'UserInvitation', id: string | null, role: UserRoles | null, email: string | null, status: UserInvitationStatuses | null, created_at: string | null, updated_at: string | null } | null };

export type RemoveUserInvitationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveUserInvitationMutation = { __typename?: 'Mutation', removeUserInvitation: { __typename?: 'RemoveUserInvitationPayload', success: boolean | null } | null };

export type ResendUserInvitationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ResendUserInvitationMutation = { __typename?: 'Mutation', resendUserInvitation: { __typename?: 'UserInvitation', id: string | null, role: UserRoles | null, email: string | null, status: UserInvitationStatuses | null, created_at: string | null, updated_at: string | null } | null };

export type CreateCustomSubscriptionMutationVariables = Exact<{
  data?: InputMaybe<CreateCustomSubscriptionInput>;
}>;


export type CreateCustomSubscriptionMutation = { __typename?: 'Mutation', createCustomSubscription: { __typename?: 'CreateCustomSubscriptionResponse', subscription: { __typename?: 'Subscription', id: number | null, status: SubscriptionStatuses | null, customer_id: string | null, period_end_date: string | null, period_start_date: string | null, cancel_date: string | null, is_cancel: boolean | null, payment_method: PaymentMethod | null, created_at: string | null, updated_at: string | null, transaction_id: string | null, notes: string | null } | null } | null };

export type UpdateCustomSubscriptionMutationVariables = Exact<{
  data?: InputMaybe<UpdateCustomSubscriptionInput>;
}>;


export type UpdateCustomSubscriptionMutation = { __typename?: 'Mutation', updateCustomSubscription: { __typename?: 'UpdateCustomSubscriptionResponse', subscription: { __typename?: 'Subscription', id: number | null, status: SubscriptionStatuses | null, customer_id: string | null, period_end_date: string | null, period_start_date: string | null, cancel_date: string | null, is_cancel: boolean | null, payment_method: PaymentMethod | null, created_at: string | null, updated_at: string | null, transaction_id: string | null, notes: string | null } | null } | null };

export type CancelSubscriptionNowMutationVariables = Exact<{
  data?: InputMaybe<CancelSubscriptionInput>;
}>;


export type CancelSubscriptionNowMutation = { __typename?: 'Mutation', cancelSubscriptionNow: { __typename?: 'CancelSubscriptionResponse', subscription: { __typename?: 'Subscription', id: number | null, status: SubscriptionStatuses | null, customer_id: string | null, period_end_date: string | null, period_start_date: string | null, cancel_date: string | null, is_cancel: boolean | null, payment_method: PaymentMethod | null, created_at: string | null, updated_at: string | null, transaction_id: string | null, notes: string | null } | null } | null };

export type CancelSubscriptionMutationVariables = Exact<{
  data?: InputMaybe<CancelSubscriptionInput>;
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription: { __typename?: 'CancelSubscriptionResponse', subscription: { __typename?: 'Subscription', id: number | null, status: SubscriptionStatuses | null, customer_id: string | null, period_end_date: string | null, period_start_date: string | null, cancel_date: string | null, is_cancel: boolean | null, payment_method: PaymentMethod | null, created_at: string | null, updated_at: string | null, transaction_id: string | null, notes: string | null } | null } | null };

export type CancelledSubscriptionsMetricsQueryVariables = Exact<{
  where: SubscriptionCancelWhereInput;
}>;


export type CancelledSubscriptionsMetricsQuery = { __typename?: 'Query', cancelledSubscriptionsMetrics: Array<{ __typename?: 'CancelledSubscriptionMetric', date: string, count: number, previousDate: string, previousCount: number }> | null };

export type SubscriptionCancelledByFilterQueryVariables = Exact<{
  where: SubscriptionCancelledByFilterInput;
}>;


export type SubscriptionCancelledByFilterQuery = { __typename?: 'Query', subscriptionCancelledByFilter: { __typename?: 'SubscriptionCancelledByFilter', total: number, items: Array<{ __typename?: 'Subscription', id: number | null, type: SubscriptionType | null, status: SubscriptionStatuses | null, customer_id: string | null, period_end_date: string | null, period_start_date: string | null, cancel_date: string | null, is_cancel: boolean | null, payment_method: PaymentMethod | null, created_at: string | null, updated_at: string | null, transaction_id: string | null, notes: string | null, plan: { __typename?: 'Plan', id: number | null, title: string | null, title_front: string | null, description: string | null, price: string | null } | null, user: { __typename?: 'User', id: number, email: string, name: string, user_status: UserStatus | null } | null }> } | null };

export type FetchUserSubscriberEventsQueryVariables = Exact<{
  where?: InputMaybe<UsersSubscriberEventsWhere>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchUserSubscriberEventsQuery = { __typename?: 'Query', userSubscriberEvents: { __typename?: 'UsersSubscriberEventsPayload', count: number | null, items: Array<{ __typename?: 'UserSubscriberEvent', id: number | null, created_at: string | null, user_id: number | null, event_id: number | null, user: { __typename?: 'User', name: string, email: string, id: number } | null, event: { __typename?: 'SubscriberEvent', name: string | null, id: number | null, description: string | null } | null } | null> | null } | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: number, name: string, email: string, avatar: string | null, gender: Gender | null, birthday: string | null, social_providers: Array<{ __typename?: 'UserSocialProviders', id: number, provider: SocialProviders | null, provider_id: string | null, primary: boolean | null } | null> | null, roles_on_users: Array<{ __typename?: 'RolesOnUsers', role_id: number | null, role: { __typename?: 'UserRole', id: number | null, name: UserRoles | null } | null } | null> | null, subscriptions: Array<{ __typename?: 'Subscription', cancel_date: string | null, status: SubscriptionStatuses | null, payment_method: PaymentMethod | null, period_end_date: string | null, period_start_date: string | null, is_cancel: boolean | null, id: number | null, notes: string | null, plan: { __typename?: 'Plan', id: number | null, title: string | null, description: string | null, sub_title: string | null, price: string | null } | null } | null> | null, invoices: Array<{ __typename?: 'Invoice', id: number | null, transaction_id: string | null, status: InvoiceStatuses | null, created_at: string | null, updated_at: string | null, plan: { __typename?: 'Plan', title: string | null, description: string | null, sub_title: string | null, price: string | null } | null } | null> | null, card: { __typename?: 'Card', type: string | null, brand: string | null, card_number: string | null, holder_name: string | null, expiration_year: string | null, expiration_month: string | null, bank_name: string | null, bank_code: string | null, customer_card_id: string | null } | null } | null };

export type UsersQueryVariables = Exact<{
  where?: InputMaybe<UsersWhere>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<UserOrderInput>> | InputMaybe<UserOrderInput>>;
}>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersPayload', count: number | null, items: Array<{ __typename?: 'User', id: number, name: string, avatar: string | null, birthday: string | null, created_at: string | null, email: string, gender: Gender | null, updated_at: string | null, roles_on_users: Array<{ __typename?: 'RolesOnUsers', role: { __typename?: 'UserRole', id: number | null, name: UserRoles | null } | null } | null> | null, social_providers: Array<{ __typename?: 'UserSocialProviders', id: number, primary: boolean | null, provider: SocialProviders | null, url_register: string | null, user_id: number | null } | null> | null, subscriptions: Array<{ __typename?: 'Subscription', id: number | null, status: SubscriptionStatuses | null, created_at: string | null, transaction_id: string | null, notes: string | null, cancel_date: string | null, payment_method: PaymentMethod | null, period_end_date: string | null, period_start_date: string | null, is_cancel: boolean | null, plan: { __typename?: 'Plan', id: number | null, title: string | null, description: string | null, sub_title: string | null, price: string | null, frequency: PlanFrequency | null } | null } | null> | null } | null> | null } | null };

export type ToggleAdministratorUserRoleMutationVariables = Exact<{
  data?: InputMaybe<ToggleAdministratorUserRoleInput>;
}>;


export type ToggleAdministratorUserRoleMutation = { __typename?: 'Mutation', toggleAdministratorUserRole: { __typename?: 'User', id: number, email: string, name: string, roles_on_users: Array<{ __typename?: 'RolesOnUsers', role_id: number | null } | null> | null } | null };

export type UserProvidersQueryVariables = Exact<{
  where?: InputMaybe<UserSocialProvidersWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<UserSocialProvidersOrderInput>> | InputMaybe<UserSocialProvidersOrderInput>>;
}>;


export type UserProvidersQuery = { __typename?: 'Query', userProviders: { __typename?: 'UserSocialProvidersResponse', count: number | null, items: Array<{ __typename?: 'UserSocialProviders', id: number, provider: SocialProviders | null, primary: boolean | null, url_register: string | null, created_at: string | null, users: { __typename?: 'User', id: number, name: string, created_at: string | null, avatar: string | null, birthday: string | null, email: string, gender: Gender | null, user_status: UserStatus | null, updated_at: string | null, roles_on_users: Array<{ __typename?: 'RolesOnUsers', role: { __typename?: 'UserRole', id: number | null, name: UserRoles | null } | null } | null> | null, subscriptions: Array<{ __typename?: 'Subscription', id: number | null, status: SubscriptionStatuses | null, notes: string | null, plan: { __typename?: 'Plan', id: number | null, title: string | null, frequency: PlanFrequency | null } | null } | null> | null } | null } | null> | null } | null };

export type UpdateUserMutationVariables = Exact<{
  data?: InputMaybe<UpdateUserInput>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: number, name: string, email: string, password: string | null, created_at: string | null, updated_at: string | null, avatar: string | null, gender: Gender | null, birthday: string | null, user_status: UserStatus | null, roles_on_users: Array<{ __typename?: 'RolesOnUsers', role: { __typename?: 'UserRole', id: number | null, name: UserRoles | null } | null } | null> | null } | null };

export type UpdateUserandRolesMutationVariables = Exact<{
  data?: InputMaybe<UpdateUserWithRolesInput>;
}>;


export type UpdateUserandRolesMutation = { __typename?: 'Mutation', updateUserandRoles: { __typename?: 'User', id: number, name: string, email: string, password: string | null, created_at: string | null, updated_at: string | null, avatar: string | null, gender: Gender | null, birthday: string | null, roles_on_users: Array<{ __typename?: 'RolesOnUsers', role: { __typename?: 'UserRole', id: number | null, name: UserRoles | null } | null } | null> | null } | null };

export type EasyDataUsersQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<InputMaybe<UserOrderInput>> | InputMaybe<UserOrderInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UsersWhere>;
}>;


export type EasyDataUsersQuery = { __typename?: 'Query', easyDataUsers: { __typename?: 'UsersPayload', count: number | null, items: Array<{ __typename?: 'User', id: number, name: string, email: string, password: string | null, created_at: string | null, updated_at: string | null, avatar: string | null, gender: Gender | null, birthday: string | null, user_status: UserStatus | null, roles_on_users: Array<{ __typename?: 'RolesOnUsers', role_id: number | null, role: { __typename?: 'UserRole', name: UserRoles | null, id: number | null } | null } | null> | null } | null> | null } | null };

export type UserQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: number, name: string, created_at: string | null, avatar: string | null, birthday: string | null, email: string, gender: Gender | null, updated_at: string | null, roles_on_users: Array<{ __typename?: 'RolesOnUsers', role: { __typename?: 'UserRole', id: number | null, name: UserRoles | null } | null } | null> | null, social_providers: Array<{ __typename?: 'UserSocialProviders', id: number, primary: boolean | null, provider: SocialProviders | null, url_register: string | null, user_id: number | null, created_at: string | null } | null> | null, subscriptions: Array<{ __typename?: 'Subscription', id: number | null, status: SubscriptionStatuses | null, created_at: string | null, transaction_id: string | null, notes: string | null, cancel_date: string | null, payment_method: PaymentMethod | null, period_end_date: string | null, period_start_date: string | null, is_cancel: boolean | null, subscription_url: string | null, plan: { __typename?: 'Plan', id: number | null, title: string | null, description: string | null, sub_title: string | null, price: string | null, frequency: PlanFrequency | null } | null } | null> | null } | null };

export type AdminDisableAccountMutationVariables = Exact<{
  data?: InputMaybe<AdminDisableUserInput>;
}>;


export type AdminDisableAccountMutation = { __typename?: 'Mutation', adminDisableAccount: { __typename?: 'disableAccountResponse', message: string | null, success: boolean | null } | null };


export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    user {
      id
    }
    token
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const SignupDocument = gql`
    mutation Signup($email: String!, $password: String!, $name: String!, $url: String!, $site: Site!) {
  signup(email: $email, password: $password, name: $name, url: $url, site: $site) {
    user {
      id
    }
    token
  }
}
    `;
export type SignupMutationFn = Apollo.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      name: // value for 'name'
 *      url: // value for 'url'
 *      site: // value for 'site'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: Apollo.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SignupMutation, SignupMutationVariables>(SignupDocument, options);
}
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($email: String!, $redirectUrl: String!, $form: String!) {
  forgotPassword(email: $email, redirectUrl: $redirectUrl, form: $form) {
    success
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      redirectUrl: // value for 'redirectUrl'
 *      form: // value for 'form'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
}
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($email: String!, $password: String!, $token: String!) {
  changePassword(email: $email, password: $password, token: $token) {
    user {
      id
    }
    token
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
}
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const GoogleSignInDocument = gql`
    mutation googleSignIn($token: String!, $url: String!, $site: Site!) {
  googleSignup(token: $token, url: $url, site: $site) {
    user {
      id
    }
    token
  }
}
    `;
export type GoogleSignInMutationFn = Apollo.MutationFunction<GoogleSignInMutation, GoogleSignInMutationVariables>;

/**
 * __useGoogleSignInMutation__
 *
 * To run a mutation, you first call `useGoogleSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleSignInMutation, { data, loading, error }] = useGoogleSignInMutation({
 *   variables: {
 *      token: // value for 'token'
 *      url: // value for 'url'
 *      site: // value for 'site'
 *   },
 * });
 */
export function useGoogleSignInMutation(baseOptions?: Apollo.MutationHookOptions<GoogleSignInMutation, GoogleSignInMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<GoogleSignInMutation, GoogleSignInMutationVariables>(GoogleSignInDocument, options);
}
export type GoogleSignInMutationHookResult = ReturnType<typeof useGoogleSignInMutation>;
export type GoogleSignInMutationResult = Apollo.MutationResult<GoogleSignInMutation>;
export type GoogleSignInMutationOptions = Apollo.BaseMutationOptions<GoogleSignInMutation, GoogleSignInMutationVariables>;
export const PlansDocument = gql`
    query Plans($where: PlansWhereInput) {
  plans(where: $where) {
    items {
      id
      title
      title_front
      sub_title
      description
      helper_text
      price
      status
      frequency
    }
  }
}
    `;

/**
 * __usePlansQuery__
 *
 * To run a query within a React component, call `usePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlansQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePlansQuery(baseOptions?: Apollo.QueryHookOptions<PlansQuery, PlansQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<PlansQuery, PlansQueryVariables>(PlansDocument, options);
}
export function usePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlansQuery, PlansQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<PlansQuery, PlansQueryVariables>(PlansDocument, options);
}
export function usePlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlansQuery, PlansQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<PlansQuery, PlansQueryVariables>(PlansDocument, options);
}
export type PlansQueryHookResult = ReturnType<typeof usePlansQuery>;
export type PlansLazyQueryHookResult = ReturnType<typeof usePlansLazyQuery>;
export type PlansSuspenseQueryHookResult = ReturnType<typeof usePlansSuspenseQuery>;
export type PlansQueryResult = Apollo.QueryResult<PlansQuery, PlansQueryVariables>;
export const SubscriptionsNextExpireReportDocument = gql`
    mutation SubscriptionsNextExpireReport($data: SubscriptionsNextExpireReportInput) {
  subscriptionsNextExpireReport(data: $data) {
    id
    name
    type
    files {
      id
      name
      path
      created_at
      updated_at
    }
    count_files
    requested_by
    status
    site
    status_message
    from_date
    to_date
    created_at
    updated_at
  }
}
    `;
export type SubscriptionsNextExpireReportMutationFn = Apollo.MutationFunction<SubscriptionsNextExpireReportMutation, SubscriptionsNextExpireReportMutationVariables>;

/**
 * __useSubscriptionsNextExpireReportMutation__
 *
 * To run a mutation, you first call `useSubscriptionsNextExpireReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsNextExpireReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriptionsNextExpireReportMutation, { data, loading, error }] = useSubscriptionsNextExpireReportMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSubscriptionsNextExpireReportMutation(baseOptions?: Apollo.MutationHookOptions<SubscriptionsNextExpireReportMutation, SubscriptionsNextExpireReportMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<SubscriptionsNextExpireReportMutation, SubscriptionsNextExpireReportMutationVariables>(SubscriptionsNextExpireReportDocument, options);
}
export type SubscriptionsNextExpireReportMutationHookResult = ReturnType<typeof useSubscriptionsNextExpireReportMutation>;
export type SubscriptionsNextExpireReportMutationResult = Apollo.MutationResult<SubscriptionsNextExpireReportMutation>;
export type SubscriptionsNextExpireReportMutationOptions = Apollo.BaseMutationOptions<SubscriptionsNextExpireReportMutation, SubscriptionsNextExpireReportMutationVariables>;
export const UserInvitationsDocument = gql`
    query userInvitations($data: userInvitationsInput) {
  userInvitations(data: $data) {
    count
    items {
      id
      role
      email
      status
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useUserInvitationsQuery__
 *
 * To run a query within a React component, call `useUserInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInvitationsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUserInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<UserInvitationsQuery, UserInvitationsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<UserInvitationsQuery, UserInvitationsQueryVariables>(UserInvitationsDocument, options);
}
export function useUserInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInvitationsQuery, UserInvitationsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<UserInvitationsQuery, UserInvitationsQueryVariables>(UserInvitationsDocument, options);
}
export function useUserInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserInvitationsQuery, UserInvitationsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<UserInvitationsQuery, UserInvitationsQueryVariables>(UserInvitationsDocument, options);
}
export type UserInvitationsQueryHookResult = ReturnType<typeof useUserInvitationsQuery>;
export type UserInvitationsLazyQueryHookResult = ReturnType<typeof useUserInvitationsLazyQuery>;
export type UserInvitationsSuspenseQueryHookResult = ReturnType<typeof useUserInvitationsSuspenseQuery>;
export type UserInvitationsQueryResult = Apollo.QueryResult<UserInvitationsQuery, UserInvitationsQueryVariables>;
export const CreateUserInvitationDocument = gql`
    mutation createUserInvitation($data: CreateUserInvitationInput) {
  createUserInvitation(data: $data) {
    id
    role
    email
    status
    created_at
    updated_at
  }
}
    `;
export type CreateUserInvitationMutationFn = Apollo.MutationFunction<CreateUserInvitationMutation, CreateUserInvitationMutationVariables>;

/**
 * __useCreateUserInvitationMutation__
 *
 * To run a mutation, you first call `useCreateUserInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserInvitationMutation, { data, loading, error }] = useCreateUserInvitationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateUserInvitationMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserInvitationMutation, CreateUserInvitationMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateUserInvitationMutation, CreateUserInvitationMutationVariables>(CreateUserInvitationDocument, options);
}
export type CreateUserInvitationMutationHookResult = ReturnType<typeof useCreateUserInvitationMutation>;
export type CreateUserInvitationMutationResult = Apollo.MutationResult<CreateUserInvitationMutation>;
export type CreateUserInvitationMutationOptions = Apollo.BaseMutationOptions<CreateUserInvitationMutation, CreateUserInvitationMutationVariables>;
export const UpdateUserInvitationDocument = gql`
    mutation updateUserInvitation($data: UpdateUserInvitationInput) {
  updateUserInvitation(data: $data) {
    id
    role
    email
    status
    created_at
    updated_at
  }
}
    `;
export type UpdateUserInvitationMutationFn = Apollo.MutationFunction<UpdateUserInvitationMutation, UpdateUserInvitationMutationVariables>;

/**
 * __useUpdateUserInvitationMutation__
 *
 * To run a mutation, you first call `useUpdateUserInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserInvitationMutation, { data, loading, error }] = useUpdateUserInvitationMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserInvitationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserInvitationMutation, UpdateUserInvitationMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateUserInvitationMutation, UpdateUserInvitationMutationVariables>(UpdateUserInvitationDocument, options);
}
export type UpdateUserInvitationMutationHookResult = ReturnType<typeof useUpdateUserInvitationMutation>;
export type UpdateUserInvitationMutationResult = Apollo.MutationResult<UpdateUserInvitationMutation>;
export type UpdateUserInvitationMutationOptions = Apollo.BaseMutationOptions<UpdateUserInvitationMutation, UpdateUserInvitationMutationVariables>;
export const RemoveUserInvitationDocument = gql`
    mutation removeUserInvitation($id: String!) {
  removeUserInvitation(id: $id) {
    success
  }
}
    `;
export type RemoveUserInvitationMutationFn = Apollo.MutationFunction<RemoveUserInvitationMutation, RemoveUserInvitationMutationVariables>;

/**
 * __useRemoveUserInvitationMutation__
 *
 * To run a mutation, you first call `useRemoveUserInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserInvitationMutation, { data, loading, error }] = useRemoveUserInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveUserInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserInvitationMutation, RemoveUserInvitationMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<RemoveUserInvitationMutation, RemoveUserInvitationMutationVariables>(RemoveUserInvitationDocument, options);
}
export type RemoveUserInvitationMutationHookResult = ReturnType<typeof useRemoveUserInvitationMutation>;
export type RemoveUserInvitationMutationResult = Apollo.MutationResult<RemoveUserInvitationMutation>;
export type RemoveUserInvitationMutationOptions = Apollo.BaseMutationOptions<RemoveUserInvitationMutation, RemoveUserInvitationMutationVariables>;
export const ResendUserInvitationDocument = gql`
    mutation resendUserInvitation($id: String!) {
  resendUserInvitation(id: $id) {
    id
    role
    email
    status
    created_at
    updated_at
  }
}
    `;
export type ResendUserInvitationMutationFn = Apollo.MutationFunction<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>;

/**
 * __useResendUserInvitationMutation__
 *
 * To run a mutation, you first call `useResendUserInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendUserInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendUserInvitationMutation, { data, loading, error }] = useResendUserInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendUserInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>(ResendUserInvitationDocument, options);
}
export type ResendUserInvitationMutationHookResult = ReturnType<typeof useResendUserInvitationMutation>;
export type ResendUserInvitationMutationResult = Apollo.MutationResult<ResendUserInvitationMutation>;
export type ResendUserInvitationMutationOptions = Apollo.BaseMutationOptions<ResendUserInvitationMutation, ResendUserInvitationMutationVariables>;
export const CreateCustomSubscriptionDocument = gql`
    mutation CreateCustomSubscription($data: CreateCustomSubscriptionInput) {
  createCustomSubscription(data: $data) {
    subscription {
      id
      status
      customer_id
      period_end_date
      period_start_date
      cancel_date
      is_cancel
      payment_method
      created_at
      updated_at
      transaction_id
      notes
    }
  }
}
    `;
export type CreateCustomSubscriptionMutationFn = Apollo.MutationFunction<CreateCustomSubscriptionMutation, CreateCustomSubscriptionMutationVariables>;

/**
 * __useCreateCustomSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateCustomSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomSubscriptionMutation, { data, loading, error }] = useCreateCustomSubscriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCustomSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomSubscriptionMutation, CreateCustomSubscriptionMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CreateCustomSubscriptionMutation, CreateCustomSubscriptionMutationVariables>(CreateCustomSubscriptionDocument, options);
}
export type CreateCustomSubscriptionMutationHookResult = ReturnType<typeof useCreateCustomSubscriptionMutation>;
export type CreateCustomSubscriptionMutationResult = Apollo.MutationResult<CreateCustomSubscriptionMutation>;
export type CreateCustomSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateCustomSubscriptionMutation, CreateCustomSubscriptionMutationVariables>;
export const UpdateCustomSubscriptionDocument = gql`
    mutation UpdateCustomSubscription($data: UpdateCustomSubscriptionInput) {
  updateCustomSubscription(data: $data) {
    subscription {
      id
      status
      customer_id
      period_end_date
      period_start_date
      cancel_date
      is_cancel
      payment_method
      created_at
      updated_at
      transaction_id
      notes
    }
  }
}
    `;
export type UpdateCustomSubscriptionMutationFn = Apollo.MutationFunction<UpdateCustomSubscriptionMutation, UpdateCustomSubscriptionMutationVariables>;

/**
 * __useUpdateCustomSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateCustomSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomSubscriptionMutation, { data, loading, error }] = useUpdateCustomSubscriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCustomSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomSubscriptionMutation, UpdateCustomSubscriptionMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateCustomSubscriptionMutation, UpdateCustomSubscriptionMutationVariables>(UpdateCustomSubscriptionDocument, options);
}
export type UpdateCustomSubscriptionMutationHookResult = ReturnType<typeof useUpdateCustomSubscriptionMutation>;
export type UpdateCustomSubscriptionMutationResult = Apollo.MutationResult<UpdateCustomSubscriptionMutation>;
export type UpdateCustomSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateCustomSubscriptionMutation, UpdateCustomSubscriptionMutationVariables>;
export const CancelSubscriptionNowDocument = gql`
    mutation CancelSubscriptionNow($data: CancelSubscriptionInput) {
  cancelSubscriptionNow(data: $data) {
    subscription {
      id
      status
      customer_id
      period_end_date
      period_start_date
      cancel_date
      is_cancel
      payment_method
      created_at
      updated_at
      transaction_id
      notes
    }
  }
}
    `;
export type CancelSubscriptionNowMutationFn = Apollo.MutationFunction<CancelSubscriptionNowMutation, CancelSubscriptionNowMutationVariables>;

/**
 * __useCancelSubscriptionNowMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionNowMutation, { data, loading, error }] = useCancelSubscriptionNowMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCancelSubscriptionNowMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionNowMutation, CancelSubscriptionNowMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CancelSubscriptionNowMutation, CancelSubscriptionNowMutationVariables>(CancelSubscriptionNowDocument, options);
}
export type CancelSubscriptionNowMutationHookResult = ReturnType<typeof useCancelSubscriptionNowMutation>;
export type CancelSubscriptionNowMutationResult = Apollo.MutationResult<CancelSubscriptionNowMutation>;
export type CancelSubscriptionNowMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionNowMutation, CancelSubscriptionNowMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription($data: CancelSubscriptionInput) {
  cancelSubscription(data: $data) {
    subscription {
      id
      status
      customer_id
      period_end_date
      period_start_date
      cancel_date
      is_cancel
      payment_method
      created_at
      updated_at
      transaction_id
      notes
    }
  }
}
    `;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
}
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const CancelledSubscriptionsMetricsDocument = gql`
    query CancelledSubscriptionsMetrics($where: SubscriptionCancelWhereInput!) {
  cancelledSubscriptionsMetrics(where: $where) {
    date
    count
    previousDate
    previousCount
  }
}
    `;

/**
 * __useCancelledSubscriptionsMetricsQuery__
 *
 * To run a query within a React component, call `useCancelledSubscriptionsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancelledSubscriptionsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancelledSubscriptionsMetricsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCancelledSubscriptionsMetricsQuery(baseOptions: Apollo.QueryHookOptions<CancelledSubscriptionsMetricsQuery, CancelledSubscriptionsMetricsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<CancelledSubscriptionsMetricsQuery, CancelledSubscriptionsMetricsQueryVariables>(CancelledSubscriptionsMetricsDocument, options);
}
export function useCancelledSubscriptionsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CancelledSubscriptionsMetricsQuery, CancelledSubscriptionsMetricsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<CancelledSubscriptionsMetricsQuery, CancelledSubscriptionsMetricsQueryVariables>(CancelledSubscriptionsMetricsDocument, options);
}
export function useCancelledSubscriptionsMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CancelledSubscriptionsMetricsQuery, CancelledSubscriptionsMetricsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<CancelledSubscriptionsMetricsQuery, CancelledSubscriptionsMetricsQueryVariables>(CancelledSubscriptionsMetricsDocument, options);
}
export type CancelledSubscriptionsMetricsQueryHookResult = ReturnType<typeof useCancelledSubscriptionsMetricsQuery>;
export type CancelledSubscriptionsMetricsLazyQueryHookResult = ReturnType<typeof useCancelledSubscriptionsMetricsLazyQuery>;
export type CancelledSubscriptionsMetricsSuspenseQueryHookResult = ReturnType<typeof useCancelledSubscriptionsMetricsSuspenseQuery>;
export type CancelledSubscriptionsMetricsQueryResult = Apollo.QueryResult<CancelledSubscriptionsMetricsQuery, CancelledSubscriptionsMetricsQueryVariables>;
export const SubscriptionCancelledByFilterDocument = gql`
    query SubscriptionCancelledByFilter($where: SubscriptionCancelledByFilterInput!) {
  subscriptionCancelledByFilter(where: $where) {
    items {
      id
      plan {
        id
        title
        title_front
        description
        price
      }
      type
      status
      customer_id
      period_end_date
      period_start_date
      cancel_date
      is_cancel
      payment_method
      user {
        id
        email
        name
        user_status
      }
      created_at
      updated_at
      transaction_id
      notes
    }
    total
  }
}
    `;

/**
 * __useSubscriptionCancelledByFilterQuery__
 *
 * To run a query within a React component, call `useSubscriptionCancelledByFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionCancelledByFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionCancelledByFilterQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSubscriptionCancelledByFilterQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionCancelledByFilterQuery, SubscriptionCancelledByFilterQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<SubscriptionCancelledByFilterQuery, SubscriptionCancelledByFilterQueryVariables>(SubscriptionCancelledByFilterDocument, options);
}
export function useSubscriptionCancelledByFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionCancelledByFilterQuery, SubscriptionCancelledByFilterQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<SubscriptionCancelledByFilterQuery, SubscriptionCancelledByFilterQueryVariables>(SubscriptionCancelledByFilterDocument, options);
}
export function useSubscriptionCancelledByFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscriptionCancelledByFilterQuery, SubscriptionCancelledByFilterQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<SubscriptionCancelledByFilterQuery, SubscriptionCancelledByFilterQueryVariables>(SubscriptionCancelledByFilterDocument, options);
}
export type SubscriptionCancelledByFilterQueryHookResult = ReturnType<typeof useSubscriptionCancelledByFilterQuery>;
export type SubscriptionCancelledByFilterLazyQueryHookResult = ReturnType<typeof useSubscriptionCancelledByFilterLazyQuery>;
export type SubscriptionCancelledByFilterSuspenseQueryHookResult = ReturnType<typeof useSubscriptionCancelledByFilterSuspenseQuery>;
export type SubscriptionCancelledByFilterQueryResult = Apollo.QueryResult<SubscriptionCancelledByFilterQuery, SubscriptionCancelledByFilterQueryVariables>;
export const FetchUserSubscriberEventsDocument = gql`
    query FetchUserSubscriberEvents($where: UsersSubscriberEventsWhere, $take: Int, $skip: Int) {
  userSubscriberEvents(where: $where, take: $take, skip: $skip) {
    items {
      id
      created_at
      user_id
      event_id
      user {
        name
        email
        id
      }
      event {
        name
        id
        description
      }
    }
    count
  }
}
    `;

/**
 * __useFetchUserSubscriberEventsQuery__
 *
 * To run a query within a React component, call `useFetchUserSubscriberEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUserSubscriberEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUserSubscriberEventsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useFetchUserSubscriberEventsQuery(baseOptions?: Apollo.QueryHookOptions<FetchUserSubscriberEventsQuery, FetchUserSubscriberEventsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<FetchUserSubscriberEventsQuery, FetchUserSubscriberEventsQueryVariables>(FetchUserSubscriberEventsDocument, options);
}
export function useFetchUserSubscriberEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchUserSubscriberEventsQuery, FetchUserSubscriberEventsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<FetchUserSubscriberEventsQuery, FetchUserSubscriberEventsQueryVariables>(FetchUserSubscriberEventsDocument, options);
}
export function useFetchUserSubscriberEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchUserSubscriberEventsQuery, FetchUserSubscriberEventsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<FetchUserSubscriberEventsQuery, FetchUserSubscriberEventsQueryVariables>(FetchUserSubscriberEventsDocument, options);
}
export type FetchUserSubscriberEventsQueryHookResult = ReturnType<typeof useFetchUserSubscriberEventsQuery>;
export type FetchUserSubscriberEventsLazyQueryHookResult = ReturnType<typeof useFetchUserSubscriberEventsLazyQuery>;
export type FetchUserSubscriberEventsSuspenseQueryHookResult = ReturnType<typeof useFetchUserSubscriberEventsSuspenseQuery>;
export type FetchUserSubscriberEventsQueryResult = Apollo.QueryResult<FetchUserSubscriberEventsQuery, FetchUserSubscriberEventsQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    name
    email
    avatar
    gender
    birthday
    social_providers {
      id
      provider
      provider_id
      primary
    }
    roles_on_users {
      role_id
      role {
        id
        name
      }
    }
    subscriptions {
      plan {
        id
        title
        description
        sub_title
        price
      }
      cancel_date
      status
      payment_method
      period_end_date
      period_start_date
      is_cancel
      id
      notes
    }
    invoices {
      id
      transaction_id
      status
      created_at
      updated_at
      plan {
        title
        description
        sub_title
        price
      }
    }
    card {
      type
      brand
      card_number
      holder_name
      expiration_year
      expiration_month
      bank_name
      bank_code
      customer_card_id
    }
  }
}
    `;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
}
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
}
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
}
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const UsersDocument = gql`
    query Users($where: UsersWhere, $take: Int, $skip: Int, $orderBy: [UserOrderInput]) {
  users(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    count
    items {
      id
      name
      roles_on_users {
        role {
          id
          name
        }
      }
      social_providers {
        id
        primary
        provider
        url_register
        user_id
      }
      avatar
      birthday
      created_at
      email
      gender
      subscriptions {
        id
        status
        created_at
        transaction_id
        notes
        plan {
          id
          title
          description
          sub_title
          price
          frequency
        }
        cancel_date
        payment_method
        period_end_date
        period_start_date
        is_cancel
      }
      updated_at
    }
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
}
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
}
export function useUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
}
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const ToggleAdministratorUserRoleDocument = gql`
    mutation toggleAdministratorUserRole($data: toggleAdministratorUserRoleInput) {
  toggleAdministratorUserRole(data: $data) {
    id
    email
    name
    roles_on_users {
      role_id
    }
  }
}
    `;
export type ToggleAdministratorUserRoleMutationFn = Apollo.MutationFunction<ToggleAdministratorUserRoleMutation, ToggleAdministratorUserRoleMutationVariables>;

/**
 * __useToggleAdministratorUserRoleMutation__
 *
 * To run a mutation, you first call `useToggleAdministratorUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAdministratorUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAdministratorUserRoleMutation, { data, loading, error }] = useToggleAdministratorUserRoleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useToggleAdministratorUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<ToggleAdministratorUserRoleMutation, ToggleAdministratorUserRoleMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<ToggleAdministratorUserRoleMutation, ToggleAdministratorUserRoleMutationVariables>(ToggleAdministratorUserRoleDocument, options);
}
export type ToggleAdministratorUserRoleMutationHookResult = ReturnType<typeof useToggleAdministratorUserRoleMutation>;
export type ToggleAdministratorUserRoleMutationResult = Apollo.MutationResult<ToggleAdministratorUserRoleMutation>;
export type ToggleAdministratorUserRoleMutationOptions = Apollo.BaseMutationOptions<ToggleAdministratorUserRoleMutation, ToggleAdministratorUserRoleMutationVariables>;
export const UserProvidersDocument = gql`
    query UserProviders($where: UserSocialProvidersWhereInput, $take: Int, $skip: Int, $orderBy: [UserSocialProvidersOrderInput]) {
  userProviders(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    count
    items {
      id
      provider
      primary
      url_register
      created_at
      users {
        id
        name
        roles_on_users {
          role {
            id
            name
          }
        }
        created_at
        avatar
        birthday
        created_at
        email
        gender
        user_status
        subscriptions {
          id
          status
          notes
          plan {
            id
            title
            frequency
          }
        }
        updated_at
      }
    }
  }
}
    `;

/**
 * __useUserProvidersQuery__
 *
 * To run a query within a React component, call `useUserProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProvidersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUserProvidersQuery(baseOptions?: Apollo.QueryHookOptions<UserProvidersQuery, UserProvidersQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<UserProvidersQuery, UserProvidersQueryVariables>(UserProvidersDocument, options);
}
export function useUserProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProvidersQuery, UserProvidersQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<UserProvidersQuery, UserProvidersQueryVariables>(UserProvidersDocument, options);
}
export function useUserProvidersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserProvidersQuery, UserProvidersQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<UserProvidersQuery, UserProvidersQueryVariables>(UserProvidersDocument, options);
}
export type UserProvidersQueryHookResult = ReturnType<typeof useUserProvidersQuery>;
export type UserProvidersLazyQueryHookResult = ReturnType<typeof useUserProvidersLazyQuery>;
export type UserProvidersSuspenseQueryHookResult = ReturnType<typeof useUserProvidersSuspenseQuery>;
export type UserProvidersQueryResult = Apollo.QueryResult<UserProvidersQuery, UserProvidersQueryVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($data: UpdateUserInput) {
  updateUser(data: $data) {
    id
    name
    email
    password
    created_at
    updated_at
    avatar
    gender
    birthday
    user_status
    roles_on_users {
      role {
        id
        name
      }
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
}
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserandRolesDocument = gql`
    mutation updateUserandRoles($data: UpdateUserWithRolesInput) {
  updateUserandRoles(data: $data) {
    id
    name
    email
    password
    created_at
    updated_at
    avatar
    gender
    birthday
    roles_on_users {
      role {
        id
        name
      }
    }
  }
}
    `;
export type UpdateUserandRolesMutationFn = Apollo.MutationFunction<UpdateUserandRolesMutation, UpdateUserandRolesMutationVariables>;

/**
 * __useUpdateUserandRolesMutation__
 *
 * To run a mutation, you first call `useUpdateUserandRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserandRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserandRolesMutation, { data, loading, error }] = useUpdateUserandRolesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserandRolesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserandRolesMutation, UpdateUserandRolesMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateUserandRolesMutation, UpdateUserandRolesMutationVariables>(UpdateUserandRolesDocument, options);
}
export type UpdateUserandRolesMutationHookResult = ReturnType<typeof useUpdateUserandRolesMutation>;
export type UpdateUserandRolesMutationResult = Apollo.MutationResult<UpdateUserandRolesMutation>;
export type UpdateUserandRolesMutationOptions = Apollo.BaseMutationOptions<UpdateUserandRolesMutation, UpdateUserandRolesMutationVariables>;
export const EasyDataUsersDocument = gql`
    query easyDataUsers($orderBy: [UserOrderInput], $skip: Int, $take: Int, $where: UsersWhere) {
  easyDataUsers(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
    count
    items {
      id
      name
      email
      password
      created_at
      updated_at
      avatar
      gender
      birthday
      user_status
      roles_on_users {
        role_id
        role {
          name
          id
        }
      }
    }
  }
}
    `;

/**
 * __useEasyDataUsersQuery__
 *
 * To run a query within a React component, call `useEasyDataUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEasyDataUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEasyDataUsersQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useEasyDataUsersQuery(baseOptions?: Apollo.QueryHookOptions<EasyDataUsersQuery, EasyDataUsersQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<EasyDataUsersQuery, EasyDataUsersQueryVariables>(EasyDataUsersDocument, options);
}
export function useEasyDataUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EasyDataUsersQuery, EasyDataUsersQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<EasyDataUsersQuery, EasyDataUsersQueryVariables>(EasyDataUsersDocument, options);
}
export function useEasyDataUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EasyDataUsersQuery, EasyDataUsersQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<EasyDataUsersQuery, EasyDataUsersQueryVariables>(EasyDataUsersDocument, options);
}
export type EasyDataUsersQueryHookResult = ReturnType<typeof useEasyDataUsersQuery>;
export type EasyDataUsersLazyQueryHookResult = ReturnType<typeof useEasyDataUsersLazyQuery>;
export type EasyDataUsersSuspenseQueryHookResult = ReturnType<typeof useEasyDataUsersSuspenseQuery>;
export type EasyDataUsersQueryResult = Apollo.QueryResult<EasyDataUsersQuery, EasyDataUsersQueryVariables>;
export const UserDocument = gql`
    query User($id: Int!) {
  user(id: $id) {
    id
    name
    roles_on_users {
      role {
        id
        name
      }
    }
    social_providers {
      id
      primary
      provider
      url_register
      user_id
      created_at
    }
    created_at
    avatar
    birthday
    created_at
    email
    gender
    subscriptions {
      id
      status
      created_at
      transaction_id
      notes
      plan {
        id
        title
        description
        sub_title
        price
        frequency
      }
      cancel_date
      payment_method
      period_end_date
      period_start_date
      is_cancel
      subscription_url
    }
    updated_at
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
}
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
}
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
}
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const AdminDisableAccountDocument = gql`
    mutation AdminDisableAccount($data: AdminDisableUserInput) {
  adminDisableAccount(data: $data) {
    message
    success
  }
}
    `;
export type AdminDisableAccountMutationFn = Apollo.MutationFunction<AdminDisableAccountMutation, AdminDisableAccountMutationVariables>;

/**
 * __useAdminDisableAccountMutation__
 *
 * To run a mutation, you first call `useAdminDisableAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDisableAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDisableAccountMutation, { data, loading, error }] = useAdminDisableAccountMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminDisableAccountMutation(baseOptions?: Apollo.MutationHookOptions<AdminDisableAccountMutation, AdminDisableAccountMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<AdminDisableAccountMutation, AdminDisableAccountMutationVariables>(AdminDisableAccountDocument, options);
}
export type AdminDisableAccountMutationHookResult = ReturnType<typeof useAdminDisableAccountMutation>;
export type AdminDisableAccountMutationResult = Apollo.MutationResult<AdminDisableAccountMutation>;
export type AdminDisableAccountMutationOptions = Apollo.BaseMutationOptions<AdminDisableAccountMutation, AdminDisableAccountMutationVariables>;